<div class="img-db">
    <app-img-db-header
        *ngIf="!isDbFromTraining && container"
        [isUserOwner]="isOwner"
        [container]="container"
    ></app-img-db-header>
    <div
        class="img-db-content"
        *ngIf="imageDb"
        [ngClass]="{ 'not-in-split-screen': !isDbFromTraining }"
    >
        <div class="central">
            <div class="header">
                <div class="tabs-wrapper">
                    <ul class="tab-list">
                        <li
                            class="tab-item"
                            *ngFor="let item of navItems; index as idx"
                            [id]="item + '-navigation-tab'"
                            [class.active]="isViewActive(idx)"
                            (click)="onNavClick(idx)"
                            (mouseleave)="hoveredNavItemIdx = null"
                            (mouseenter)="hoveredNavItemIdx = idx"
                        >
                            <img
                                [src]="
                                    'assets/svg/img-db/header/manage-buttons/' +
                                    (isViewActive(idx) ||
                                    hoveredNavItemIdx === idx
                                        ? item + '-hover'
                                        : item) +
                                    '.svg'
                                "
                                alt="{{ item }}-icon"
                            />
                            <span
                                id="{{ item }}-button"
                                class="tab-text"
                                [attr.aria-current]="isViewActive(idx)"
                            >{{
                                    'imgDb.header.tabs.' + item | translate
                                }}</span
                            >
                        </li>
                    </ul>
                    <div class="separation-line"></div>
                </div>
                <div
                    class="functional-buttons-wrapper"
                    [ngClass]="{
                        split: splitScreenState === SplitScreenState.DEFAULT
                    }"
                >
                    <div
                        class="upload-sort-buttons-container"
                        *ngIf="activeViewIdx === 0"
                    >
                        <label
                            *ngIf="activeViewIdx === 0"
                            for="open_file_dialog"
                            [class]="
                                canEdit
                                    ? 'upload_label'
                                    : 'upload_label disabled'
                            "
                            (mouseenter)="
                                canEdit
                                    ? (hoveredFunctionalButtonIdx = 0)
                                    : null
                            "
                            (mouseleave)="hoveredFunctionalButtonIdx = null"
                        >
                            <div
                                [class]="{
                                    'upload-button': true,
                                    disabled: !canEdit
                                }"
                            >
                                <img
                                    [src]="
                                        'assets/svg/img-db/header/functional-buttons/upload' +
                                        (hoveredFunctionalButtonIdx === 0
                                            ? '-hover'
                                            : '') +
                                        '.svg'
                                    "
                                    alt="upload-icon"
                                />
                                <span>
                                    {{
                                        'imgDb.header.functionalButtons.upload'
                                            | translate
                                    }}
                                </span>
                            </div>
                        </label>
                        <div
                            id="image-sorting-dropdown"
                            (mouseenter)="hoveredFunctionalButtonIdx = 1"
                            (mouseleave)="hoveredFunctionalButtonIdx = null"
                        >
                            <img
                                [src]="
                                    'assets/svg/img-db/header/functional-buttons/icon-twin-arrows' +
                                    (hoveredFunctionalButtonIdx === 1
                                        ? '-white'
                                        : '-grey') +
                                    '.svg'
                                "
                                alt="icon-twin-arrows"
                            />
                            <select
                                *ngIf="
                                    !isDbFromTraining ||
                                    hoveredFunctionalButtonIdx === 1 ||
                                    splitScreenState ===
                                        SplitScreenState.LEFT_CLOSED
                                "
                                [formControl]="selectedImageSortingOption"
                                (change)="onImageSortingChange()"
                            >
                                <option
                                    class="sorting-option"
                                    *ngFor="
                                        let sortingOption of imageSortingOptions
                                    "
                                    [value]="sortingOption"
                                    [id]="sortingOption"
                                >
                                    {{
                                        'imgDb.header.functionalButtons.sortingOptions.' +
                                        sortingOption | translate
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div
                        *ngIf="activeViewIdx === 1"
                        class="filter-section"
                        [title]="getFiltersString()"
                    >
                        <b
                            *ngIf="selectedCategoryNames.length !== 0"
                            class="filter-caption"
                        >{{ 'imgDb.imgLabeling.filter' | translate }}</b
                        >
                        <span class="filter-list">{{
                                getFiltersString()
                            }}</span>
                    </div>
                    <img
                        [class]="{
                            'delete-image': true,
                            disabled: isDeleteButtonDisabled()
                        }"
                        [src]="
                            'assets/svg/reusable-svg/icon-trash-can' +
                            (hoveredFunctionalButtonIdx === 2 &&
                            !isDeleteButtonDisabled()
                                ? '-hover'
                                : '') +
                            '.svg'
                        "
                        alt="delete-image-button"
                        (click)="openImageDeletionDialog()"
                        (mouseenter)="hoveredFunctionalButtonIdx = 2"
                        (mouseleave)="hoveredFunctionalButtonIdx = null"
                    />
                </div>
            </div>
            <div class="data">
                <div class="central-content-wrapper">
                    <ngx-file-drop
                        *ngIf="activeViewIdx === 0"
                        (onFileDrop)="onItemDropped($event)"
                        [accept]="getValidImageFormats()"
                        [disabled]="!canEdit"
                    >
                        <ng-template
                            ngx-file-drop-content-tmp
                            let-openFileSelector="openFileSelector"
                        >
                            <app-img-db-gallery
                                *ngIf="
                                    activeViewIdx === 0 &&
                                    imagesStorage.isStorageReady
                                "
                                (selectButtonStatusChanged)="
                                    changeSelectButtonMode($event)
                                "
                                (selectionChangedToEmpty)="
                                    imageSelectionEmpty = $event
                                "
                                (imageIndexSelectedForAnnotating)="
                                    onSwitchToAnnotateAtIndex($event)
                                "
                            ></app-img-db-gallery>
                            <button
                                id="open_file_dialog"
                                (click)="openFileSelector()"
                                class="d-none"
                                [disabled]="!canEdit"
                            ></button>
                        </ng-template>
                    </ngx-file-drop>
                    <app-img-labeling-canvas-viewer
                        *ngIf="activeViewIdx === 1"
                        [selectedCategory]="selectedEditCategory"
                        [canEdit]="canEdit"
                        [categories]="categories"
                        (zoomLevelChanged)="onZoomLevelChanged($event, true)"
                        [splitScreenState]="splitScreenState"
                    ></app-img-labeling-canvas-viewer>
                </div>
            </div>
            <div class="footer-wrapper">
                <app-footer
                    *ngIf="lengthOfImagesList"
                    [ngClass]="{
                        'zoom-out-disabled':
                            currentZoomLevel === currentMinZoom,
                        'zoom-in-disabled': currentZoomLevel === currentMaxZoom
                    }"
                    [type]="activeViewIdx === 0 ? 'overview' : 'annotate'"
                    [sortingOption]="selectedImageSortingOption.value"
                    [selectedImage]="this.imagesStorage.selectedImage$.value"
                    (zoomEmitter)="onHandleZoom($event)"
                ></app-footer>
            </div>
        </div>
        <div class="right">
            <div class="data">
                <div
                    class="side-content-wrapper"
                    [ngClass]="{
                        'in-manage-dialog': activeViewIdx === 0,
                        'in-annotate-dialog': activeViewIdx === 1
                    }"
                >
                    <div
                        class="manage-dialog-right-container"
                        *ngIf="activeViewIdx === 0"
                    >
                        <div class="category-manager-component-wrapper">
                            <app-img-db-category-manager
                                [isDbOfTraining]="isDbFromTraining"
                                [canEdit]="canEdit"
                                [imageDatabaseId]="imageDb.id"
                                [categories]="categories"
                                [selectedCategoryNames]="selectedCategoryNames"
                                [numberOfUncategorizedImages]="
                                    uncategorizedImagesCount
                                "
                                [isEmptyCategorySelected]="
                                    isEmptyCategorySelected
                                "
                                [mode]="
                                    activeViewIdx === 0
                                        ? 'overview'
                                        : 'annotate'
                                "
                                [selectedSorting]="categoriesSortingKey.option"
                                [fetchOnInit]="fetchCategoriesOnViewIndexChange"
                                (actionTaken)="
                                    handleCategoryManagerAction($event)
                                "
                            >
                            </app-img-db-category-manager>
                        </div>
                    </div>
                    <div
                        class="annotate-dialog-right-container"
                        *ngIf="activeViewIdx === 1"
                    >
                        <div class="classificator-tree-component-wrapper">
                            <app-classificator-tree
                                *ngIf="activeViewIdx === 1"
                                [canEdit]="canEdit"
                                [categories]="categories"
                                (categorySelected)="
                                    handleCategorySelect($event)
                                "
                                (categoryDeleted)="handleCategoryDelete($event)"
                            ></app-classificator-tree>
                        </div>
                        <div class="categories-right-component-wrapper">
                            <app-img-db-category-manager
                                [isDbOfTraining]="isDbFromTraining"
                                [canEdit]="canEdit"
                                [imageDatabaseId]="imageDb.id"
                                [categories]="categories"
                                [selectedCategoryNames]="selectedCategoryNames"
                                [numberOfUncategorizedImages]="
                                    uncategorizedImagesCount
                                "
                                [isEmptyCategorySelected]="
                                    isEmptyCategorySelected
                                "
                                [mode]="
                                    activeViewIdx === 0
                                        ? 'overview'
                                        : 'annotate'
                                "
                                [selectedSorting]="categoriesSortingKey.option"
                                [fetchOnInit]="fetchCategoriesOnViewIndexChange"
                                (actionTaken)="
                                    handleCategoryManagerAction($event)
                                "
                            >
                            </app-img-db-category-manager>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
